import React from 'react';
import { PageHeader } from 'components';
import { SitePageHeaderContainer } from './SitePageHeader.elements';
import { useParams } from 'react-router-dom';
import { SiteRouteQueryParams } from 'types/protein';
import { useGetPlantByIdQueryInfo } from '../hooks/useGetPlantByIdQueryInfo';

export const LinePageHeader = (): JSX.Element => {
  const { plantId } = useParams<SiteRouteQueryParams>();
  const { data: accountData } = useGetPlantByIdQueryInfo({plantId});
  const breadCrumbSettings = {
    paths: {
      customer: {
        label: accountData?.name,
        isLoading: !accountData
      },
      site: {
        label: accountData?.siteName || accountData?.name,
        isLoading: !accountData
      }
    }
  };
  return (
    <SitePageHeaderContainer>
      <PageHeader heading={''} breadCrumbSettings={breadCrumbSettings} />
    </SitePageHeaderContainer>
  );
};
